import { ApplicationRef, Component, ComponentRef, createComponent, Inject, Injectable, Type } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { IframeModalComponent } from './iframe-modal.component';
import { OrderformIframeService } from '../../services/orderform-iframe.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IframeModalService {
  private _closeSubscription: Subscription;
  private _componentRef: ComponentRef<IframeModalComponent>;

  constructor(
    private _appRef: ApplicationRef,
    @Inject(DOCUMENT) private _document: Document,
    private _orderformIframeService: OrderformIframeService
  ) {}
  open(label: string, url: string) {
    if (this._componentRef) {
      this.close();
    }

    const newHost = this._document.createElement('div');
    document.body.append(newHost);
    this._componentRef = createComponent(IframeModalComponent, {
      hostElement: newHost,
      // the environment injector instroduced for standalone
      environmentInjector: this._appRef.injector,
    });

    this._orderformIframeService.ds24_sendScrollPosition();
    this._componentRef.setInput('label', label);
    this._componentRef.setInput('url', url);
    this._componentRef.setInput('modalVisible', true);

    if (['/terms', '/privacy', '/cancellation'].find((key) => url.includes(key))) {
      let downloadURL = url.replace(`page/popup`, `download`);
      downloadURL = downloadURL.replace(`download/legal`, `download/reseller`);
      this._componentRef.setInput('downloadURL', downloadURL);
    } else {
      this._componentRef.setInput('downloadURL', undefined);
    }

    this._componentRef.changeDetectorRef.detectChanges();
    this._appRef.attachView(this._componentRef.hostView);
    this._closeSubscription = this._componentRef.instance.close.subscribe(() => {
      this.close();
    });
  }

  close() {
    this._appRef.detachView(this._componentRef.hostView);
    document.body.removeChild(this._componentRef.location.nativeElement);
    this._componentRef.destroy();
    this._closeSubscription.unsubscribe();
    this._componentRef = null;
  }
}
